const n = "_container_89lfu_11", e = "_overlay_89lfu_17", o = "_spinner_89lfu_28", r = {
  container: n,
  overlay: e,
  spinner: o
};
export {
  n as container,
  r as default,
  e as overlay,
  o as spinner
};
//# sourceMappingURL=Loading.module.css.js.map
